import axiosInstance from "../../axiosInstance";
import { normalizeApiError } from "utils/normalizeApiError";

export interface ProjectLabel {
  projectLabelUuid: string;
  projectUuid?: string;
  projectLabelName: string;
  description?: string;
  projectLabelCategory?: string; // Assuming there might be a category like work types
}

interface GetProjectLabelsResponse {
  response: ProjectLabel[];
}

export const getProjectLabels = async (
  projectUuid: string
): Promise<ProjectLabel[]> => {
  try {
    const { data } = await axiosInstance.get<GetProjectLabelsResponse>(
      `/pmo/project/${projectUuid}/get-labels`
    );
    
    let labels: ProjectLabel[] = [];
    if (data && Array.isArray((data as any).response)) labels = (data as any).response;
    else if (Array.isArray(data)) labels = data;
    else if (data && (data as any).data && Array.isArray((data as any).data)) labels = (data as any).data;
    else if (data && (data as any).response && Array.isArray((data as any).response.response)) labels = (data as any).response.response;
    
    return labels;
  } catch (error) {
    throw normalizeApiError(error);
  }
};
